import React from 'react';
import Icon from '@xo-union/tk-component-icons';
import { Question } from '../EventTypes';
import styles from './questionModule.scss';
import { trackQuestionInteraction } from '../helpers/analytics';
import { spaceBarPressed } from '../helpers/utilities';

interface Props {
  question: Question;
  editQuestion: (question: Question) => void;
  isGeneralQuestion: boolean;
  disabledQuestionUI?: boolean;
  testId?: string | number;
}

const QuestionModule: React.FC<Props> = ({
  question,
  editQuestion,
  isGeneralQuestion,
  disabledQuestionUI = false,
  testId,
}: Props) => {
  const openEditQuestionForm = (): void => {
    trackQuestionInteraction({
      selection: 'edit question initiated',
      question,
      isGeneralQuestion,
    });
    editQuestion(question);
  };

  return (
    <>
      <div
        data-testid="questionModule"
        className={disabledQuestionUI ? styles.disabledQuestionUI : styles.questionContainer}
      >
        <div className={styles.questionTitle}>
          <div>
            <span>{question.text}</span>
            {question.options && question.options.length && (
              <div className={styles.optionText}>{question.options.length} options</div>
            )}
          </div>
          <Icon
            className={styles.editQuestionCTA}
            onClick={openEditQuestionForm}
            onKeyDown={(e): void | boolean => spaceBarPressed(e) && openEditQuestionForm()}
            name="edit"
            data-testid={`edit-icon--${testId}`}
            size="md"
            tabIndex={0}
          />
        </div>
      </div>
    </>
  );
};

export default QuestionModule;
